import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Icon, Tooltip} from "antd"

class TrackingNumber extends Component {
    _checkStatus = (status, syncErrMessage) => {
        let classStatus = 'default'
        let message = 'Label chưa được sync sang FACTORY'

        if (status === 'error' || status === 'not_sync') {
            classStatus = 'error'
            message = syncErrMessage
        } else if (status === 'done_by_worker' || status === 'done_by_event') {
            classStatus = 'success'
            message = 'Label đã được sync thành công'
        }

        return <Tooltip title={message}>
            <Icon type="sync" className={classStatus}/>
        </Tooltip>
    }

    render() {
        const {syncStatus, syncErrMessage, trackingNumber} = this.props
        const status = this._checkStatus(syncStatus, syncErrMessage)

        return (
            <td className='TrackingNumber'>
                {trackingNumber} {status}
            </td>
        )
    }
}

TrackingNumber.propTypes = {
    trackingNumber: PropTypes.string,
    syncStatus: PropTypes.string,
    syncErrMessage: PropTypes.string
}

export default TrackingNumber